import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { StudentWidget } from '@/widgets/student-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.schoolIds': z.array(z.string()).optional(),
  'filter.grades': z.array(z.number()).optional(),
  'filter.classLetterNames': z.array(z.string()).optional(),
  'filter.tenantIds': z.array(z.string()).optional(),
  'filter.socialPayment': z.boolean().optional(),
  'filter.active': z.boolean().optional(),
  'filter.fio': z.string().optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/users/students')({
  staticData: {
    meta: {
      title: 'Ученики',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.STUDENTS}>
      <PageWrapper title={t('Ученики')}>
        <StudentWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
